<template>
	<div class="d-flex align-items-center" style="gap: .35rem">
		<b-form-input size="sm" type="color" :value="resolved" style="width: 48px; padding: 2px" @input="$emit('input', $event)" />
		<b-button size="sm" :variant="value === PRIMARY ? 'primary' : 'outline-secondary'" title="Follow the overlay's primary brand color" @click="$emit('input', value === PRIMARY ? resolved : PRIMARY)">Primary</b-button>
		<b-button size="sm" :variant="value === BACKGROUND ? 'primary' : 'outline-secondary'" title="Follow the overlay's background brand color" @click="$emit('input', value === BACKGROUND ? resolved : BACKGROUND)">Background</b-button>
	</div>
</template>

<script>
import { BRAND_PRIMARY, BRAND_BACKGROUND, resolveBrandColor } from '@/overlayBrand';

export default {
	props: {
		value: { type: String, default: '#ffffff' },
		overlay: { type: Object, required: true },
	},
	data() { return { PRIMARY: BRAND_PRIMARY, BACKGROUND: BRAND_BACKGROUND }},
	computed: {
		resolved() { return resolveBrandColor(this.value, this.overlay); },
	},
};
</script>
